import jscookie from "js-cookie";

export const setBeta = () => jscookie.set("beta", 1);

export default function isBeta() {
  return jscookie.get("beta") === "1";
}
